"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationMenu = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _react = require("react");
var _common = require("../common");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable eslint-comments/disable-enable-pair -- data attributes */

/** @deprecated This is not necessary anymore as notification menu is imported by TopArea. If you are interested in NotificationsMenu component itself then please import it from @ori/notification-menu package */
const NotificationMenu = ({
  environment
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    identityUrl,
    globalApiUrl,
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['identity', 'staticApi', 'globalApi']);
  const attributes = (0, _react.useMemo)(() => ({
    /* eslint-disable @typescript-eslint/naming-convention -- data attributes */
    'data-api-url': globalApiUrl,
    'data-customer-id': customerId.toString(),
    'data-identity-url': identityUrl,
    'data-static-api-url': staticApiUrl,
    'data-tenant': tenant
  }), [customerId, identityUrl, globalApiUrl, staticApiUrl, tenant]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.Spa, {
    rootAttributes: attributes,
    environment: environment,
    name: "notification-menu"
  });
};
exports.NotificationMenu = NotificationMenu;
